import Store from 'App/babel/store';

export default function ListFlowsAllowed() {
	const state = Store.getState();
	const features = state.App.accountSelf?.features;
	return features?.flow;
}
